import * as React from 'react';
import { connect } from 'react-redux';
import { goBack } from 'react-router-redux';
import {
  ButtonGroup,
  IconButton,
  Hero,
  Subtitle,
  Title,
  RouteWrapper,
} from '../../components';
import { removeCompany } from '../../redux/actions/companies';

interface Props {
  match: any;
  handleRemoveCompany: Function;
}

const Route = ({ match, handleRemoveCompany }: Props) => (
  <RouteWrapper
    title="Remove Company"
    requireAuth
    requirePermission="MANAGE_COMPANIES"
  >
    <Hero className="is-danger is-fullheight has-text-centered">
      <Title large>Remove Company?</Title>
      <Subtitle>
        Once this company is removed, you will not be able to reference them
        anymore.
      </Subtitle>
      <ButtonGroup>
        <IconButton
          className="button is-danger is-large is-outlined is-inverted"
          handleClick={() => {
            handleRemoveCompany(match.params.id);
          }}
          icon="trash"
          large
        >
          Remove Company
        </IconButton>
        <IconButton
          className="button is-danger is-outlined is-large is-inverted"
          link={`/companies/${match.params.id}`}
          icon="undo"
          large
        >
          Cancel
        </IconButton>
      </ButtonGroup>
    </Hero>
  </RouteWrapper>
);

const mapDispatchToProps = (dispatch) => ({
  handleRemoveCompany: (id) => {
    dispatch(removeCompany(id)).then((response) => {
      if (!response.error) {
        if (!response.error) {
          dispatch(goBack());
          dispatch(goBack());
        } else {
          dispatch(goBack());
        }
      } else {
        if (!response.error) {
          dispatch(goBack());
          dispatch(goBack());
        } else {
          dispatch(goBack());
        }
      }
    });
  },
});

export default connect(() => ({}), mapDispatchToProps)(Route);
